export const ROLES = {
	VOLUNTEER: 'volunteer',
	CAMPAIGN_MANAGER: 'campaign-manager',
};
